:host {
  @apply border-color-2
    bg-foreground-1
    text-color-2
    text-n1h
    relative
    m-4
    box-border
    flex
    flex-row
    border
    border-solid;

  * {
    @apply box-border;
  }
}

.container {
  @apply w-full p-4;
}

:host([closed]),
:host([closed]) .container {
  @apply hidden;
}

:host([selected]) .container {
  @apply m-0 border-none p-0;
}

@import "../../assets/styles/header";

.header {
  @apply mb-2;
}
.header .heading {
  @apply text-0h text-color-1 p-0;
}

.container[hidden] {
  @apply hidden;
}

.content {
  @apply flex;
}

.info {
  @apply py-0 px-4;
  inline-size: 70%;
  &:only-child {
    @apply w-full px-0;
  }
}

::slotted(p) {
  @apply mt-0;
}

::slotted(a) {
  @apply focus-base;
  color: theme("backgroundColor.brand");
}

::slotted(a:focus) {
  @apply focus-outset;
}

.image-frame {
  inline-size: theme("width[1/4]");
  img {
    @apply max-w-full;
  }
}

::slotted(img) {
  @apply max-w-full;
}

@include base-component();
